import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    gap: '1rem',
    justifyContent: 'space-between',
    position: 'relative',
    width: '100%',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  topRow: {
    display: 'flex',
    gap: '1rem',
  },
  bottomRow: {
    position: 'absolute',
    display: 'flex',
    gap: '1rem',
    right: 0,
    top: '100%',
    marginTop: '1rem',
  },
}));

export default useStyles;
